module.exports = __webpack_public_path__ + "img/banner_sound.5b4f9299.png";